import { mutator } from 'satcheljs';
import getStore from '../store/store';
import initializeSettings, {
    type INITIALIZE_PBP_SETTINGSActionMessage,
} from '../actions/initializeSettings';

/**
 * Initializes the personal booking page settings in the store.
 */
/* eslint-disable-next-line owa-custom-rules/prefer-mutator-action -- (https://aka.ms/OWALintWiki)
 * Baseline. DO NOT COPY AND PASTE!
 *	> Please use a mutatorAction if action is defined in the same package */
const defaultExport: (actionMessage: INITIALIZE_PBP_SETTINGSActionMessage) => void = mutator(
    initializeSettings,
    actionMessage => {
        const store = getStore();
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (13,5): Type 'PublishingSettings | undefined' is not assignable to type 'PublishingSettings'.
        // @ts-expect-error
        store.publishingSettings = actionMessage.pbpSettings.PublishingSettings;
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (17,5): Type 'boolean | undefined' is not assignable to type 'boolean'.
        // @ts-expect-error
        store.isAnonymousSharingEnabled = actionMessage.pbpSettings.IsAnonymousSharingAllowed;
    }
);
export default defaultExport;
